import { Component, computed, HostBinding, input, model } from '@angular/core';

@Component({
  selector: 'app-pan-star-rating',
  templateUrl: './pan-star-rating.component.html',
  styleUrl: './pan-star-rating.component.scss',
  standalone: false,
})
export class PanStarRatingComponent {
  public disabled = input<boolean>(false);
  public readonly = input<boolean>(false);
  public maxStars = input<number>(5);
  public size = input<'sm' | 'md' | 'lg'>('md');
  public name = input<string>();
  public id = input<string>();

  public rating = model<number>(0);

  @HostBinding('class')
  public get hostClasses() {
    return this.classes().join(' ');
  }

  public classes = computed(() => {
    return ['star-rating', this.disabled() ? 'star-rating-disabled' : '', this.readonly() ? 'star-rating-readonly' : ''].filter(Boolean);
  });

  public get stars(): number[] {
    return Array(this.maxStars())
      .fill(0)
      .map((_, i) => i + 1);
  }

  public isSelected(star: number): boolean {
    return star <= this.rating();
  }

  public onStarClick(star: number): void {
    if (this.disabled() || this.readonly()) return;

    if (this.rating() === star) {
      this.rating.set(0);
    } else {
      this.rating.set(star);
    }
  }
}
